// Function to check if two objects are identical
const isIdentical = (obj1, obj2) => {
    return Object.keys(obj1).every(key => obj1[key] === obj2[key]);
};

// Filter array1 to include only non-identical objects from array2
export const nonIdenticalObjects = (array1, array2) => array1.filter(obj1 => !array2.some(obj2 => isIdentical(obj1, obj2)));